import React, { useState } from "react";
import PostAPI from "../../APICalls/PostAPI";

const WhatsappMessageViaChefType = ({ setLoading }) => {
  const [imageId, setImageId] = useState("");
  const [templateID, setTemplateID] = useState("");
  const [userType, setUserType] = useState(""); // Added state for userType

  const handleSubmit = () => {
    setLoading(true);
    let environment = process.env.REACT_APP_NODE_ENV;
    let whatsappBrodcastAPI;
    if (environment === "PRODUCTION" || environment === undefined) {
      whatsappBrodcastAPI = process.env.REACT_APP_PROD_WHATSAPP_BROADCASTING;
    } else {
      whatsappBrodcastAPI = process.env.REACT_APP_DEV_WHATSAPP_BROADCASTING;
    }

    if (templateID === "") {
      alert("Please enter the templateID to submit");
      return;
    }
    if (userType === "") {
      alert("Please select the userType to submit");
      return;
    }
    const dataToPost = {
      imageId: imageId !== "" ? imageId : undefined,
      templateID: templateID,
      type: userType,
    };

    // Assuming PostAPI is defined somewhere else
    PostAPI(whatsappBrodcastAPI, dataToPost)
      .then((res) => {
        setLoading(false);
        setImageId("");
        setTemplateID("");
        setUserType("");
        alert("Push notification added successfully");
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
        alert("Failed to add push notification, Try again later!! ", e);
      });
  };

  return (
    <div className="card ">
      <div className="card-body mx-2">
        <h3 className="my-3  mx-2 ">Send notifications via WhatsApp</h3>
        <div>
          <form>
            <div className="form-row">
              <div className="col-sm-12 col-md-12 col-lg-12 my-3">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="validationTooltipUsernamePrepend"
                    >
                      Image Id
                    </span>
                  </div>
                  <input
                    type="text"
                    value={imageId}
                    onChange={(e) => setImageId(e.target.value)}
                    className="form-control"
                    id="imageId"
                    placeholder="Image Id"
                    aria-describedby="Message"
                    required
                  />
                </div>
              </div>

              {/* Dropdown for userType */}
              <div className="col-sm-12 col-md-12 col-lg-12 my-3">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="validationTooltipUsernamePrepend"
                    >
                      User Type
                    </span>
                  </div>
                  <select
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                    className="form-control"
                    id="userType"
                    required
                  >
                    <option value="">Select User Type</option>
                    <option value="AVAILABLE">Available Chefs</option>
                    <option value="UNAVAILABLE">Unvailable Chefs</option>
                    <option value="REGISTERED">Registered Chefs</option>
                    <option value="REMOVED">Removed Chefs</option>
                    {/* Add more options as needed */}
                  </select>
                </div>
              </div>

              <div className="col-sm-12 col-md-12 col-lg-12 my-3">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="validationTooltipUsernamePrepend"
                    >
                      Template Id
                    </span>
                  </div>
                  <input
                    type="text"
                    value={templateID}
                    onChange={(e) => setTemplateID(e.target.value)}
                    className="form-control"
                    id="templateID"
                    placeholder="Template Id"
                    aria-describedby="Message"
                    required
                  />
                </div>
              </div>
            </div>
          </form>
          <div className="col-sm-12 mx-2 my-5">
            <button
              className="btn btn-primary btn-block"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappMessageViaChefType;
